let _this

export default {
    name: "plam-vein",
    props: {
        palmVeinList: {
            type: Array,
            default() {
                return window.g.pocPalmVeinDeviceList
            }
        },
        staffInfo: {
            type: Object,
            default:{}
        }
    },
    data() {
        return {
            palmPrintFeature:'',
            palmVeinDialog:false,
            palmVeinSelectModel: '',
            palmVeinFlag: false,
            isStartSocket: false,
            isSocketFailed: false,
            pocStart:false,
            pocSocket: null,
            palmList:[],
            searchDep:{page:1},
            successFlag:false,

        }
    },
    watch: {
        palmVeinDialog(){
            if(!this.palmVeinDialog){
                this.palmVeinFlag = false
                if(this.pocSocket)
                this.closePoc()
            }
        },
        palmVeinSelectModel(){
            if(this.palmVeinSelectModel == '' && this.isStartSocket) {
                this.closePoc()
            }
        }
    },
    mounted() {
        _this = this
    },
    methods: {
        deletePalmVein(){
            _this.successFlag = false
            _this.$emit('updatePalmPrintFeature', '')
         },
        linkPoc(){
            this.isSocketFailed = false
            if(!this.palmVeinSelectModel){
              this.palmVeinFlag = true;
              return
            }
            this.deletePalmVein();
            this.isStartSocket = true
            this.pocStart = true
            this.pocSocket = new this.signalr.HubConnectionBuilder().withUrl('/palmprint/links/input',
                {
                skipNegotiation: true, //跳过协商
                transport: this.signalr.HttpTransportType.WebSockets, //使用WebSocket协议通讯
                }
            ).build()
            console.log('palmVeinIp',Number(this.palmVeinSelectModel))
            this.pocSocket.start().then(() => {
                this.pocSocket.invoke('ClientConnectedAsync',Number(this.palmVeinSelectModel)).catch(err => console.error('发送失败',err))
            }).catch(err => {
                this.isSocketFailed = true
            })
            // 开启扫描
            this.pocSocket.on('readerStarted',function() {
                console.log('开启扫描')
            })
            // 扫描成功
            this.pocSocket.on('receivePalmprint',function(data) {
                _this.palmPrintFeature = data
                _this.$emit('updatePalmPrintFeature', _this.palmPrintFeature)
                _this.successFlag = true
                setTimeout(() => {
                    _this.closePoc() // 接收到数据后自动关闭WebSocket连接
                },3000)
            })
            this.pocSocket.on('error',function(msg) {
                console.log('error',msg)
                this.closePoc()
            })
        },
        closePoc(){
            this.pocSocket.stop().then(() => {
                console.log('closed')
            }).catch(err => {
                console.log('关闭失败',err)
            });
            this.isStartSocket= false
        },
        closePalm(){
            this.palmVeinFlag = false
            this.palmVeinDialog = false
            this.palmVeinSelectModel = ''
        },
        // 获取掌纹列表
        getPalmVeinList() {
            let params = {
                enabledPaging: true,
                page:this.searchDep.page,
                perPage:10,
                types:[2015]
            }
            if(this.$root.curNodeInfo.id){
                params.queryNodeId = this.$root.curNodeInfo.id;
              }
            this.$ajax.post('Device/Paginate',params,{headers:{noLoading: true }}).then(res => {
                if(res.data.success) {
                    this.searchDep.pageCount =res.data.data.itemCount;
                    if(this.searchDep.page > 1){
                        this.palmList = this.palmList.concat(res.data.data.items);
                      }else{
                        this.palmList = res.data.data.items;
                    }
                }
            })
        },
        openDepPanel:function(flag){
            if(flag){
              this.palmVeinFlag = false
              this.palmVeinSelectModel = '';
              this.searchDep.query = '';
              this.searchDep.page = 1;
              this.getPalmVeinList();
            }
          },
    }
}


// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/palmVein.js